<template>
    <div>
        <v-btn icon color="primary" class="mr-2" @click="showSetStarsDialog">
            <v-icon class="mr-1">mdi-star-outline</v-icon>
            {{ coachStars }}
        </v-btn>

        <set-stars-dialog :coach="coach" ref="stars" @success="onSuccess"/>
    </div>
</template>

<script>

import SetStarsDialog from '@/components/student/SetStarsDialog'
import {db} from '@/utils/Firebase'

export default {
    components: {
        SetStarsDialog,
    },
    data() {
        return {
            stars: '',
            coach: null,
        }
    },
    computed: {
        coachId(vm = this) {
            return vm.$route.params.uid
        },
        coachStars(vm = this) {
            if (vm.coach?.rating) return Number(vm.coach.rating.stars).toFixed(1).replace('.0', '')
            return '0'
        },
        canRate(vm = this) {
            return vm.account?.studentSubscription?.coachId === vm.coachId
        }
    },
    async mounted() {
        const vm = this
        await vm.loadCoachData()
    },
    methods: {
        showSetStarsDialog() {
            const vm = this
            if (!vm.canRate) return vm.toast(vm.$t('common.cant_rate_coach'), 'error')
            vm.$refs.stars.show()
        },
        async loadCoachData() {
            const vm = this
            let coachRef = await db.collection('users').doc(vm.coachId).get()
            vm.coach = coachRef.data()
        },
        onSuccess() {
            const vm = this
            vm.loadCoachData()
        }
    }
}
</script>